import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICompanyGroup } from "../../utils/types/models";

export default createEntityReducer<ICompanyGroup>(Endpoint.CompanyGroups, Endpoint.CompanyGroupsList);
